import * as React from 'react';
import { SurveyWrapper } from 'src/styles/survey';
import { Grid, Typography, Button, FormControl, FormGroup, FormControlLabel, Checkbox, IconButton, Link, Input } from '@material-ui/core';
import IconBackButton from '@material-ui/icons/KeyboardBackspace';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';

export default class SurveyModuleCountryComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            isUpdateTitle: false,
            countryRegions: []
        }
        this.SaveAsDraft = this.SaveAsDraft.bind(this);
        this.PublishSurvey = this.PublishSurvey.bind(this);
        this.assignUnassignCountry = this.assignUnassignCountry.bind(this);
        this.GotoModule = this.GotoModule.bind(this);
        this.updateSurveyTitle = this.updateSurveyTitle.bind(this);
        this.handleTitleChange = this.handleTitleChange.bind(this);
    }

    // adding flag property to select and deselect region countries
    componentDidMount() {
        if (this.props.countryRegions && this.props.countryRegions.length > 0) {
            const countryRegions = this.props.countryRegions.map((regionItem: any) => ({
                selected: regionItem.countries && regionItem.countries.length > 0 ? regionItem.countries.filter((x: { isChecked: any; }) => (!x.isChecked || x.isChecked === undefined)).length > 0 ? false : true : false,
                ...regionItem
            }));

            this.setState({ countryRegions })
        }
    }

    // appending select/deselect flag to render region checbox accordingly
    UNSAFE_componentWillReceiveProps(nextProps: any) {
        if (nextProps.countryRegions) {
            const countryRegions = nextProps.countryRegions.map((regionItem: any) => ({
                selected: regionItem.countries && regionItem.countries.length > 0 ? regionItem.countries.filter((x: { isChecked: any; }) => (!x.isChecked || x.isChecked === undefined)).length > 0 ? false : true : false,
                ...regionItem
            }));

            this.setState({ countryRegions })
        }
    }

    SaveAsDraft() {
        this.props.SaveAsDraft();
    }

    PublishSurvey() {
        this.props.PublishSurvey();
    }

    GotoModule() {
        this.props.GotoAssignment(false)
    }

    updateSurveyTitle(isUpdateTitle: any) {
        this.setState({ isUpdateTitle })
    }

    handleTitleChange = (event: any) => {
        const BaseSurvey: any = this.props.baseSurvey;
        BaseSurvey.title = event.target.value;
        this.props.handleSurveyDetailsChange(BaseSurvey);
    }

    assignUnassignCountry = (event: any) => {
        const selectedCountry = {
            id: event.target.value,
            isChecked: event.target.checked
        };

        this.props.AssignUnassignCountry([], selectedCountry);
    }

    // handle select/deselect of region
    handleSelectDeselectRegion = (event: any, index: number) => {
        const countryRegions = this.state.countryRegions
        countryRegions[index].selected = event.target.checked;

        countryRegions[index].countries.forEach((countryItem: any) => {
            const selectedCountry = {
                id: countryItem.id,
                isChecked: event.target.checked
            };

            this.props.AssignUnassignCountry([], selectedCountry);
        })

        this.setState({ countryRegions })
    }

    render() {
        const status = this.props.baseSurvey && this.props.baseSurvey.status ? parseInt(this.props.baseSurvey.status, 0) : 0;

        return (
            <SurveyWrapper>
                <div className="pageContainer surveyScreen">
                    <div className="pageHeading">
                        <Grid container={true} spacing={8}>
                            <Grid item={true} xs={6}>
                                <div className="pageHeadingTitle">
                                    <Typography component="h2" variant="title" align="left" gutterBottom={true} className="pageTitle">
                                        Assignment
                                    </Typography>
                                </div>
                            </Grid>
                            {(status === 1 || status === 0) && <Grid item={true} xs={6}>
                                <div className="text-right">
                                    <Button type="button" className="btn-blue" variant="outlined" size="medium" onClick={this.SaveAsDraft}>
                                        Save as Draft
                                    </Button>
                                    &nbsp;&nbsp;
                                    <Button type="button" className="btn-blue-primary" variant="outlined" size="medium" onClick={this.PublishSurvey}>
                                        <CloudUploadIcon /> &nbsp; Publish Survey
                                    </Button>
                                </div>
                            </Grid>}
                        </Grid>
                    </div>

                    <div className="pageBreadcrumb">
                        <Grid container={true} spacing={8}>
                            <Grid item={true} xs={6}>
                                <div className="pageTitleSection">
                                    <IconButton onClick={this.GotoModule} className="backButton" color="inherit" aria-label="Open drawer">
                                        <IconBackButton />
                                    </IconButton>
                                    <Typography component="h2" variant="title" align="left" gutterBottom={true} className="pageTitle">

                                        {this.state.isUpdateTitle ? <Grid item={true} xs={12}>
                                            <FormControl margin="normal" required={true} fullWidth={true}>
                                                <Input id="title"
                                                    name="title"
                                                    value={this.props.baseSurvey && this.props.baseSurvey.title || ''}
                                                    onChange={this.handleTitleChange}
                                                    onBlur={this.updateSurveyTitle.bind(this, false)}
                                                    placeholder="Add Survey Name"
                                                    fullWidth={true}
                                                />
                                                {this.props.surveyValidation.isTitleValid && <span className="errorMessage">Title field is required</span>}
                                            </FormControl >
                                        </Grid> : this.props.baseSurvey.title}
                                    </Typography>
                                    {!this.state.isUpdateTitle && (status === 1 || status === 0) && <Typography className="headingLink">
                                        <Link onClick={this.updateSurveyTitle.bind(this, true)} className="pageLink">
                                            Rename Survey
                                        </Link>
                                    </Typography>
                                    }
                                </div>
                            </Grid>
                        </Grid>
                    </div>

                    <div className="pageContent">
                        <div className="contentSection">
                            <Grid container={true}>
                                {
                                    this.state.countryRegions && this.state.countryRegions.length > 0 && this.state.countryRegions.map((region: any, key: any) => {
                                        return <Grid key={key} item={true} xs={3}>
                                            <div className="checkboxGroupControl">
                                                <FormControl className="checkboxControl" margin="normal" fullWidth={true}>
                                                    <FormGroup className="checkboxGroup" row={true}>
                                                        {
                                                            <FormControlLabel className="checkboxLabel"
                                                                control={
                                                                    <Checkbox
                                                                        checked={region.selected}
                                                                        name={region.region}
                                                                        color="primary"
                                                                        onChange={(event: any) => this.handleSelectDeselectRegion(event, key)}
                                                                        className="checkboxField"
                                                                    />
                                                                }
                                                                label={<span className="regionTitle">{region.region}</span>}
                                                            />
                                                        }
                                                    </FormGroup>
                                                </FormControl>
                                            </div>

                                            {
                                                region.countries.map((element: any, countryKey: any) => {
                                                    return <Grid key={countryKey} item={true} sm={12} >
                                                        <div className="checkboxGroupControl">
                                                            <FormControl className="checkboxControl" margin="normal" fullWidth={true}>
                                                                <FormGroup className="checkboxGroup" row={true}>
                                                                    {
                                                                        <FormControlLabel className="checkboxLabel"
                                                                            control={
                                                                                <Checkbox
                                                                                    checked={element.isChecked}
                                                                                    name={element.name}
                                                                                    value={element.id.toString()}
                                                                                    color="primary"
                                                                                    onChange={(event) => this.assignUnassignCountry(event)}
                                                                                    className="checkboxField"
                                                                                />
                                                                            }
                                                                            label={element.name}
                                                                        />
                                                                    }
                                                                </FormGroup>
                                                            </FormControl>
                                                        </div>
                                                    </Grid>
                                                })
                                            }
                                        </Grid>
                                    })
                                }
                            </Grid>
                        </div>
                    </div>
                </div>
            </SurveyWrapper>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/surveys/SurveyModuleCountryComponent.tsx